import moment from 'moment' 
import tz from 'moment-timezone'
export default{
    fnPrintDate: function(_date){
	
        let _month=_date.getMonth();
        _month="0"+(_month+1);
        let _day="0"+_date.getDate();
        
        return _date.getFullYear()+"-"+_month.substring(_month.length-2,_month.length)+"-"+_day.substring(_day.length-2,_day.length);
        
    }

    ,fnPrintDateByNum: function(_date){
        if(_date!=null && _date!=""){
            let year=_date.substring(0,4);
            let month=_date.substring(4,6);
            let day=_date.substring(6,8);
            return year+"-"+month+"-"+day;
        }
        return "";
    }

    ,fnConvertStrDate: function(str,exp){
        let year;
        let month;
        let day;
        if(exp == null){
            year = str.substring(0,4);
            month = str.substring(4,6);
            day = str.substring(6,8);  
        }else{
            str=str.split(exp);
            year = str[0];
            month = str[1];
            day = str[2];  
        }
        return new Date(year,month,day);
    }
    
    ,fnConvertDateStr: function(paramDate,exp){
        let _date = new Date(paramDate);
        let month = _date.getMonth() + 1;
        let day = _date.getDate();
        let year = _date.getFullYear();
        let _month = month < 10 ? "0"+ month: month;
        let _day = day < 10 ? "0"+ day: day;
        if(exp == null){
            return year+ "/"+ _month+ "/" + _day;
        }else{
            return year+ exp+ _month+ exp + _day;
        }
    }

    ,fnOnFileDownload:function(seq){
		window.location='/file/download/'+seq;
    }
    
    ,fnConvertDateTimeStr : function(_date,exp){	
        if(_date==null){
            return '';
        }

        let dt = new Date(_date);

        if(typeof _date == 'string'){
            let _splitDate = _date.split(' ');
            let _yymmdd = _splitDate[0].split('-');
            let _hhmmss = _splitDate[1].split(':');
            dt = new Date(_yymmdd[0], _yymmdd[1]-1, _yymmdd[2], _hhmmss[0], _hhmmss[1], _hhmmss[2]);
        }
        
        let month = dt.getMonth() + 1;
        let day = dt.getDate();
        let year = dt.getFullYear();
        let hh=dt.getHours();
        let min=dt.getMinutes();
        let ss=dt.getSeconds();
        day=day<10?"0"+day:day;
        hh=hh<10?"0"+hh:hh;
        min=min<10?"0"+min:min;
        ss=ss<10?"0"+ss:ss;
        let _month = month < 10 ? "0"+ month: month;
        if(exp == null){
            return year+ "/"+ _month+ "/" + day+" "+hh+":"+min+":"+ss;
        }else{
            return year+ exp+ _month+ exp + day+" "+hh+":"+min+":"+ss;
        }
    }

    ,toDay_YYYYMMDD: function (n) {
        let now = new Date();
        if (n != undefined && n != null) {
          now.setDate(now.getDate()+parseInt(n))
        }
        let y = now.getFullYear();
        let m = now.getMonth() + 1;
        let d = now.getDate();
        return '' + y +'-'+ (m < 10 ? '0' : '') + m +'-'+ (d < 10 ? '0' : '') + d;
    }

    ,toDay_MMDD: function (paramDate) {
        let _date = new Date(paramDate);
        let month = _date.getMonth() + 1;
        let day = _date.getDate();
        let _month = month < 10 ? "0"+ month: month;
        let _day = day < 10 ? "0"+ day: day;
        
        return _month+ '-' + _day;
    }

    ,fnConvertStrPrintDateByNum: function(_date){
        if(_date!=null && _date!=""){
            let date = _date.replaceAll("-","");
            let year=date.substring(0,4);
            let month=date.substring(4,6);
            let day=date.substring(6,8);
            return year+"-"+month+"-"+day;
        }
        return "";
    }

    ,fnNumberFormat: function(inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    ,fnGrpSendYnCode:function(){
        const _list = [{code:"1",value:"수신"}, {code:"2", value:"미수신"}];
        return _list;
    }
    ,fnGrpAgreeYnCode:function(){
        const _list = [{code:"1",value:"동의"}, {code:"0", value:"미동의"}];
        return _list;
    }
    ,fnBrdOrderingCode:function(){
        const _list = [{code:"1",value:"최신순"}, {code:"2", value:"인기순"}];
        return _list;
    }
    ,fnStatusOrderingCode:function(){
        const _list = [{cmm_sys_cd:"",cmm_sys_titl:"전체"},{cmm_sys_cd:"Y",cmm_sys_titl:"미게시"}, {cmm_sys_cd:"N", cmm_sys_titl:"게시"}];
        return _list;
    }
    ,fnSetRandomUUID:function(){
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    ,fnSetDefaultDate(_date){
        return moment.utc(_date).tz("Asia/Seoul").format('YYYYMMDD');
    }
}